export default __webpack_public_path__ + "static/media/feature_dropdown.9ca852ba.jpg";